import { constructUrl } from '@flicent/fieldpulse-react-component-library-frontend';

import { CustomFormTemplatePageUriParams } from '@/types';
import { ROUTE } from '@/constants';


export const constructCustomFormTemplatePageUrl = (uriParams: CustomFormTemplatePageUriParams) => {
  return constructUrl<CustomFormTemplatePageUriParams>(ROUTE.customFormTemplate, uriParams)
}